import { FormCentralizer } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { UserForm } from '../_components/UserForm';
import { useCreateUser } from '../_hooks/user';

export const CreateUserPage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { mutateAsync: createUser } = useCreateUser();

  return (
    <FormCentralizer>
      <UserForm
        initialValues={{
          // 作成時のisEmailNotificationEnabledの初期値はBEで制御しているため、FEから送ったパラメータで上書きはされない。
          // 処理の統一の観点から明示的にtrueを渡すようにする。
          isEmailNotificationEnabled: true,
        }}
        onSubmit={async (values) => {
          try {
            const res = await createUser(values);

            await Promise.all([
              openMessage(
                'success',
                t(
                  'message-created-user-and-sent-password-initialization-email',
                ),
              ),
              (async () => {
                navigate(`/tenant-manager/users/${res.id}`, { replace: true });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
